module.exports = __webpack_public_path__ + "media/Video_switch_to_dispensary.d05bef9d.mp4";